<template>
  <b-modal id="LoginForm" hide-footer hide-header centered>
    <div class="login-form">
      <div class="login-close clearfix">
        <img class="login-icon" src="../../assets/close.png" @click="$bvModal.hide('LoginForm')">
      </div>
      <div class="login-box" @keyup.enter="dologin">
        <div class="title-center">
          <div :class="type == 0 ? 'active title' : 'title'" @click="typeChange(0)">学生登录</div>
          <!-- <div :class="type == 1 ? 'active title' : 'title'" @click="typeChange(1)">管理员登录</div> -->
        </div>
        <div class="input-box clearfix">
          <img src="../../assets/home_icon18.png" class="icon">
          <input type="text" class="ipt" placeholder="请输入账号" v-model="form.username"/>
        </div>
        <div class="input-box clearfix">
          <img src="../../assets/home_icon19.png" class="icon">
          <input type="password" class="ipt" placeholder="请输入密码" v-model="form.password"/>
        </div>
        <!-- <div class="input-box clearfix">
            <img src="../../assets/home_icon18.png" class="icon">
            <input type="text" class="ipt" placeholder="请输入手机号码" v-model="phoneData.phone" />
          </div>
          <div class="input-box clearfix input-checkcode">
            <img src="../../assets/home_icon19.png" class="icon">
            <input type="text" class="ipt" placeholder="请输入验证码" v-model="phoneData.checkcode"/>
            <b-button :disabled="yzmloading != 0" class="btn btn-primary m-l checkcode" @click.prevent="getyzm" variant="primary">
                  获取验证码<span v-show="yzmloading > 0">({{ yzmloading }})</span>
            </b-button>
          </div> -->
        <b-button class="mt-3 login-btn" @click="dologin">登录</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {dologin} from "@/api";

export default {
  name: 'loginForm',
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
      phoneData: {
        phone: undefined,
        checkcode: undefined,
      },
      isPhone: false,
      // yzmloading: false,
      // yzmloading: 0,
      user: undefined,
      type: 0,
    }
  },
  methods: {
    // 学生登录
    async stuLogin() {
      if (!this.form.username) {
        this.$bvToast.toast("用户名不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      if (!this.form.password) {
        this.$bvToast.toast("密码不能为空", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
        return;
      }
      dologin(this.form).then(async (res1) => {
        const res = await this.axios.post("/student/login");
        this.user = res.data
        this.$store.commit("LOGIN", this.user);
        const info = await this.axios.get("/student/info");
        if (info.data.length > 0) {
          this.$store.commit("LOGINBAK", info.data);
          if (info.data && info.data.length > 1) {
            this.$refs.SelectMajor.open((e) => {
              this.goHome(e);
            }, true);
          } else {
            this.goHome(info.data[0]);
          }
        } else {
          this.$router.push({path: "/main/readyExam"});
        }
      }).catch((err) => {
        this.$bvToast.toast("登陆失败，用户名或密码错误", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
      });
    },
    // 管理员登录
    // async admLogin () {
    //   if (!this.form.username) {
    //     this.$bvToast.toast("用户名不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   if (!this.form.password) {
    //     this.$bvToast.toast("密码不能为空", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     });
    //     return;
    //   }
    //   await this.axios.post("/portal/admin/login", this.form)
    //     .then((res) => {
    //       let username = window.btoa(window.btoa(this.form.username)); // 编码
    //       let password = window.btoa(window.btoa(this.form.password)); // 编码
    //       window.location.href = `${process.env.VUE_APP_MANAGEMENT_SYSTEM}?u_=${username}&p_=${password}`
    //     })
    // },
    async goHome(user) {
      this.user.regInfo = user;
      this.$store.commit("LOGIN", this.user);
      const params = {
        schoolId: user.schoolId,
      };
      const {data} = await this.axios.get("/comm/findSysConfig", {
        params,
      });
      this.$store.commit("SYSCONFIG", data);
      this.$router.push({path: "/main/home"});
    },
    // getyzm () {
    //   this.yzmloading = -1;
    //   const reg_phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    //   if ( !reg_phone.test( this.phoneData.phone ) ) {
    //     this.$bvToast.toast( "请输入正确格式的手机号", {
    //       title: "提示",
    //       variant: "danger",
    //       solid: true,
    //     } );
    //     this.yzmloading = 0;
    //     return;
    //   }
    //   this.axios
    //     .post( "/student/sendCheckCode", { phone: this.phoneData.phone } )
    //     .then( ( res ) => {
    //       this.$bvToast.toast( "验证码已发送", {
    //         title: "提示",
    //         variant: "success",
    //         solid: true,
    //       } );
    //       const Inter = setInterval( () => {
    //         this.yzmloading--;
    //         if ( this.yzmloading <= 0 ) {
    //           clearInterval( Inter );
    //         }
    //       }, 1000 );
    //       this.yzmloading = 60;
    //     } )
    //     .catch( () => {
    //       this.yzmloading = 0;
    //     } );
    // },
    typeChange(type) {
      this.type = type
      this.form = {
        username: null,
        password: null,
      }
    },
    dologin() {
      if (this.type == 1) {
        this.admLogin()
      } else {
        this.stuLogin()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 登录模态框宽度modal-content
::v-deep(.modal-dialog) {
  width: 400px;

  .modal-content {
    height: 374px;
  }

  .modal-body {
    padding: 0px;
  }
}

.login-close {
  // margin-bottom: 10px;
  padding: 20px;

  .login-icon {
    width: 15px;
    height: 15px;
    cursor: pointer;
    float: right;
  }
}

.login-box {
  padding: 50px;
  padding-top: 0;

  .title-center {
    display: flex;
    flex-flow: row;
    justify-content: center;

    .title {
      font-size: 18px;
      cursor: pointer;
      line-height: 30px;
      margin-bottom: 40px;
      width: 50%;
      text-align: center;
      color: #333333;
    }

    .active {
      font-weight: 700;
      color: #930B00;
    }
  }

  .input-box {
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #dddddd;
    border-radius: 5px;
    height: 38px;
    margin-bottom: 20px;

    .icon {
      float: left;
      width: 14px;
      height: 14px;
      margin: 12px;
    }

    .ipt {
      float: left;
      width: calc(100% - 38px);
      border: none;
      outline: none;
      background-color: transparent;
      height: 36px;
    }
  }

  .input-checkcode {
    .ipt {
      width: calc(100% - 148px);
    }

    .checkcode {
      display: inline-block;
      float: right;
    }
  }

  .login-btn {
    border-radius: 5px;
    width: 100%;
    height: 38px;
    border: none;
    outline: none;
    cursor: pointer;
    color: #ffffff;
    margin: 10px 0;
    font-size: 14px;
    font-weight: 400;
    background-color: #930B00;
  }
}
</style>
